module.exports = __webpack_public_path__ + "img/view-icon3.16abb7dc.png";